import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { shape, string } from 'prop-types';

import hasApiErrors from '../../common/utils/utils';
import ShowPasswordByIcon from '../../common/ShowPasswordByIcon';
import { updatePassword } from '../../api';
import { userDetails } from '../../constants';
import { PasswordFormContainer } from '../../common/Styles/HeaderStyles';
import { Button, ErrorMsg, PageLoader, InputFormField } from '../../common';
import {
  onlyRequiredValidationRules,
  passwordValidationRules,
} from '../../constants/UserConstants';

export default function EditPassword({ userInfo }) {
  const { register, handleSubmit, errors, watch, reset, setError } = useForm({
    mode: 'onChange',
  });
  const [isLoading, setIsLoading] = useState({ loader: false, type: 'button' });
  const [showPassword, setShowPassword] = useState({
    old_password: false,
    new_password: false,
  });
  const [apiError, setApiError] = useState({});

  const isNewPassword = watch('new_password');

  const onSubmit = (data) => {
    setIsLoading({ loader: true, type: 'button' });
    updatePassword(data, userInfo.id).then((response) => {
      if (response.status === 400) {
        setApiError(response.data);
        Object.keys(response.data).forEach((key) => {
          setError(key, {
            type: 'manual',
            message: Array.isArray(response.data[key])
              ? response.data[key][0]
              : response.data[key],
          });
        });
        setIsLoading({ loader: false, type: 'button' });
      } else if (response.status === 200) {
        setIsLoading({ loader: false, type: 'button' });
        toast.success('Password Updated!');
        reset();
      }
    });
  };

  const checkFields = () => {
    if (
      Object.values(watch()).length === 0 ||
      (Object.values(watch())[0] === undefined &&
        Object.values(watch())[1] === undefined) ||
      (Object.values(watch())[0] === '' && Object.values(watch())[1] === '')
    ) {
      return true;
    }
    return false;
  };

  const generateHTML = (item) => {
    const fields = [];
    let validationRules = onlyRequiredValidationRules;
    if (item.key === 'new_password') {
      validationRules = passwordValidationRules;
    }
    fields.push(
      <label htmlFor={item.label} key={item.key}>
        {item.label}
        <br />
        <input
          className={errors?.email ? 'form-control' : 'form-control mb-2'}
          defaultValue={userInfo[item.key]}
          type={showPassword[item.key] ? 'text' : item.type}
          placeholder={item.placeholder}
          id={item.label}
          name={item.key}
          onChange={(event) =>
            setApiError({
              ...apiError,
              [event.target.name]: '',
            })
          }
          ref={register(validationRules)}
        />
        <ShowPasswordByIcon
          isPasswordEyeOpen={showPassword[item.key]}
          setIsPasswordEyeOpen={(value) =>
            setShowPassword({ ...showPassword, [item.key]: value })
          }
          value={watch()[item.key]}
        />
      </label>,
    );
    return fields;
  };

  return (
    <PasswordFormContainer>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-6">
            <InputFormField className="mt-3">
              {userDetails
                .filter((part) => part.section === 3)
                .map((item) => (
                  <React.Fragment key={item.key}>
                    {generateHTML(item)}
                    <ErrorMsg>{errors?.[item.key]?.message}</ErrorMsg>
                  </React.Fragment>
                ))}
            </InputFormField>
          </div>
          <div className="col-md-6">
            <InputFormField className="mt-3">
              {userDetails
                .filter((part) => part.section === 4)
                .map((item) => (
                  <React.Fragment key={item.key}>
                    {generateHTML(item)}
                    <ErrorMsg>{errors?.[item.key]?.message}</ErrorMsg>
                  </React.Fragment>
                ))}
            </InputFormField>
          </div>
          <Button
            className={
              checkFields()
                ? 'btn btn-primary m-3 p-2 disabled'
                : 'btn btn-primary m-3 p-2'
            }
            disabled={checkFields() || hasApiErrors(errors) || !isNewPassword}
          >
            {isLoading.loader && isLoading.type === 'button' ? (
              <PageLoader color="#FFF" type="button" />
            ) : (
              'Update password'
            )}
          </Button>
        </div>
      </form>
    </PasswordFormContainer>
  );
}

EditPassword.propTypes = {
  userInfo: shape({
    id: string,
  }).isRequired,
};
